"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GEO_ATTRIBUTE = exports.ATTRIBUTE = exports.DATE = exports.FACT = exports.METRIC = exports.BUCKETS = exports.ALL_TIME = exports.GRANULARITY = exports.SHOW_ON_SECONDARY_AXIS = exports.SHOW_IN_PERCENT = exports.FILTERS = void 0;
// (C) 2019-2020 GoodData Corporation
// Buckets
exports.FILTERS = "filters";
exports.SHOW_IN_PERCENT = "showInPercent";
exports.SHOW_ON_SECONDARY_AXIS = "showOnSecondaryAxis";
exports.GRANULARITY = {
    date: "GDC.time.date",
    week: "GDC.time.week_us",
    month: "GDC.time.month",
    quarter: "GDC.time.quarter",
    year: "GDC.time.year",
};
exports.ALL_TIME = "all_time";
exports.BUCKETS = "buckets";
// Types
exports.METRIC = "metric";
exports.FACT = "fact";
exports.DATE = "date";
exports.ATTRIBUTE = "attribute";
exports.GEO_ATTRIBUTE = "geo_attribute";
//# sourceMappingURL=bucket.js.map